import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import 'moment-duration-format';
import DatePicker from 'react-datepicker';

import DataTable from '../data-table/data-table';
import './global.css';
import { filterGlobal } from './global.actions';
import Loader from '../loader-component/loader';

class Global extends React.Component {

    state = {
        from: moment().subtract(30, 'd'),
        to: null,
    };

    componentDidMount() {
        this.filter();
    }

    filter = () => {
        this.props.filterGlobal({
            from: this.state.from && this.state.from.toISOString(),
            to: this.state.to && this.state.to.toISOString(),
        });
    };

    handleChange = ({ from = this.state.from, to = this.state.to }) => {
        if (from && from.isAfter(to)) {
            to = from;
        }
        this.setState({ from, to });
    };

    period = () => {
        const { from, to } = this.state;
        const minDate = moment('01-06-2018', 'DD-MM-YYYY');
        return (
            <div className='period-container'>
                <DatePicker
                    placeholderText='data inicial'
                    minDate={minDate}
                    maxDate={moment().subtract(2, 'd')}
                    startDate={from}
                    endDate={to}
                    selectsStart
                    readOnly
                    isClearable
                    selected={from}
                    onChange={date => this.handleChange({ from: date })}
                />
                <DatePicker
                    placeholderText='data final'
                    minDate={minDate}
                    maxDate={moment().subtract(1, 'd')}
                    startDate={from}
                    endDate={to}
                    selectsEnd
                    readOnly
                    isClearable
                    selected={to}
                    onChange={date => this.handleChange({ to: date })}
                />
                <button title='Filtrar' className='filter-btn' onClick={this.filter}><i className='fa fa-filter' /></button>
            </div>
        );
    };

    render() {
        return (
            <div className='courses-container'>
                <Loader show={ this.props.loading ? true : false } message={'Carregando, por favor aguarde...'} />
                <DataTable
                    extra={this.period}
                    className='trainers-table'
                    data={this.props.trainers}
                    columns={COLUMNS}
                    exportName={`trainers-${moment().toISOString()}.csv`}
                />
            </div>
        );
    }
}

const mapStateToProps = ({ global }) => ({
    trainers: global.data,
    loading: global.loading,
});
const mapDispatchToProps = dispatch => bindActionCreators({ filterGlobal }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Global);

const COLUMNS = [
    { Header: 'Nome', searchable: true, accessor: 'name' },
    { Header: 'E-mail', searchable: true, accessor: 'email' },
    {
        Header: 'Horas de vídeo assistidas',
        accessor: 'studiedSeconds',
        Cell: row => <div style={{ textAlign: 'center' }}>{formatDuration(row.value)}</div>,
    },
];

function formatDuration(seconds) {
    return moment.duration(seconds, 'seconds')
        .format(seconds >= 3600 ? 'hh [hr(s)]' : 'm [min(s)]', { usePlural: false });
}



// WEBPACK FOOTER //
// ./src/components/global/global.js